import {
  getCopilotMessageHTMLElements,
  setElementMikeInitialized,
  setElementMikePreparing,
} from "../../../helpers/copilotMessageElement";

const listeners = new Map<
  string,
  {
    callback: () => void;
    cancelled: boolean;
  }
>();

function runListener(id: string) {
  const messageItems = getCopilotMessageHTMLElements();

  if (messageItems.every((x) => !x.mikePreparing)) {
    const item = messageItems.find(
      (x) => id == x.mikeId && x.mikeVisible && !x.mikeInitialized,
    );

    if (item) {
      setElementMikePreparing(item.element, true);

      const listener = listeners.get(id);

      if (listener && !listener?.cancelled) {
        setElementMikeInitialized(item.element, true);

        listeners.set(id, { ...listener, cancelled: true });
        listener?.callback();
      }

      return setTimeout(() => {
        setElementMikePreparing(item.element, false);
      }, 1500);
    }
  }

  return setTimeout(() => {
    runListener(id);
  }, 500);
}

export const addSequentialLoadingListener = (
  id: string,
  callback: () => void,
) => {
  listeners.set(id, { callback, cancelled: false });

  const timeout = runListener(id);

  return () => {
    if (timeout) clearTimeout(timeout);

    const listener = listeners.get(id);

    if (listener) {
      listener.cancelled = true;
      listeners.delete(id);
    }
  };
};
